import type { BlurViewProps } from '@sbaiahmed1/react-native-blur';
import type { CSSProperties } from 'react';

// `BlurViewProps.overlayColor` is RN `ColorValue`; only the string form is
// meaningful on web — narrow at runtime instead of casting blindly. Shared by
// BaseStack and EffectsStack so the two web paths emit identical blur styles.
export const getWebBlurStyles = (
  blurConfig: BlurViewProps | undefined,
): CSSProperties | undefined => {
  if (!blurConfig) return undefined;
  const { blurAmount, overlayColor } = blurConfig;
  if (typeof blurAmount !== 'number' || blurAmount < 0) return undefined;
  return {
    WebkitBackdropFilter: `blur(${blurAmount}px)`,
    backdropFilter: `blur(${blurAmount}px)`,
    ...(typeof overlayColor === 'string' ? { backgroundColor: overlayColor } : {}),
  };
};
